import React from 'react';
import { getBusinessSubscriptionModel } from 'src/redux/action/dashLayoutHeading.action';

interface InfoItem {
  title: string;
  value: string | number;
}

interface Section {
  data: InfoItem[];
  title: string;
}

const InfoSection: React.FC<{ items: InfoItem[], title: string }> = ({ items, title }) => (
  <div className="col-span-2 2xl:col-span-1 border-[1px] border-almost-white p-2 bg-almost-white rounded-xl">
    <p className='text-lg font-medium text-secondary-0 mb-1'>{title}</p>
    {items.map((item, idx) => (
      <div key={idx} className="flex justify-between w-full">
        <p className='font-medium'>{item.title}</p>
        <p className='text-secondary-0 text-sm'>{item.value}</p>
      </div>
    ))}
  </div>
);

const SubscriptionInfo: React.FC = () => {
  const userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '{}');
  const businessId = userInfo?.businessInfo?.id;
  const { data } = getBusinessSubscriptionModel(businessId);

  const sections: Section[] = [
    { data: data?.subscriptionInfo || [], title: 'Subscription Info' },
    { data: data?.pricingInfo || [], title: 'Pricing Info' },
    { data: data?.usageInfo || [], title: 'Usage Info' },
    { data: data?.paymentInfo || [], title: 'Payment Info' },
  ];

  return (
    <div className="w-full border-[1px] border-almost-white rounded-xl py-6 text-black overflow-hidden relative">
      <div className="flex justify-between px-4 mb-4">
        <p className="font-semibold text-xl">Subscription</p>
      </div>
      <div className="grid grid-cols-4 gap-4 p-2">
        {sections.map((section, idx) => (
          <InfoSection key={idx} items={section.data} title={section.title} />
        ))}
      </div>
    </div>
  );
};

export default SubscriptionInfo;